import { render, staticRenderFns } from "./News.vue?vue&type=template&id=0b1128fc&"
import script from "./news.js?vue&type=script&lang=js&"
export * from "./news.js?vue&type=script&lang=js&"
import style0 from "./News.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports